const BasqueCountrySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110863)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.169434 22.6084C0.634746 26.1797 2.04272 29.4543 4.13467 32.1759L14.7826 22.6084H0.169434Z"
        fill="#D80027"
      />
      <path
        d="M17.3917 39.8301V25.2168L7.82422 35.8648C10.5459 37.9568 13.8204 39.3648 17.3917 39.8301Z"
        fill="#D80027"
      />
      <path
        d="M17.3917 0.168945C13.8204 0.634258 10.5459 2.04223 7.82422 4.13418L17.3917 14.7823V0.168945Z"
        fill="#D80027"
      />
      <path
        d="M0.169434 17.3907H14.7826L4.13459 7.82324C2.04264 10.5448 0.634668 13.8194 0.169434 17.3907Z"
        fill="#D80027"
      />
      <path
        d="M22.6084 0.168945V14.7822L32.1761 4.13418C29.4544 2.04238 26.1798 0.63418 22.6084 0.168945Z"
        fill="#D80027"
      />
      <path
        d="M39.8306 17.3908C39.3653 13.8195 37.9573 10.5449 35.8653 7.82324L25.2173 17.3908H39.8306Z"
        fill="#D80027"
      />
      <path
        d="M25.2173 22.6084L35.8654 32.176C37.9573 29.4543 39.3653 26.1797 39.8306 22.6084H25.2173Z"
        fill="#D80027"
      />
      <path
        d="M22.6084 39.8301C26.1797 39.3648 29.4544 37.9568 32.176 35.8648L22.6084 25.2168V39.8301Z"
        fill="#D80027"
      />
      <path
        d="M35.8669 32.1786L23.6892 20.0009L23.6891 20.0008L35.8669 7.82301C35.3417 7.14051 34.7672 6.48395 34.142 5.85863C33.5169 5.23348 32.8602 4.65887 32.1777 4.13379L19.9999 16.3115H19.9998L7.82211 4.13379C7.13961 4.65895 6.48297 5.2334 5.85766 5.85863C5.2325 6.48395 4.65789 7.14051 4.13281 7.82309L16.3105 20.0007L16.3106 20.0008L4.13289 32.1786C4.65805 32.8611 5.23258 33.5177 5.85773 34.143C6.48297 34.7682 7.13961 35.3428 7.82219 35.8679L19.9998 23.6901L32.1777 35.8679C32.8601 35.3427 33.5167 34.7682 34.142 34.143C34.7673 33.5177 35.3417 32.8611 35.8669 32.1786Z"
        fill="#496E2D"
      />
      <path
        d="M22.6087 39.8307V22.6089V22.6087H39.8307C39.942 21.7548 40 20.8841 40 20C40 19.1159 39.942 18.2453 39.8307 17.3914H22.6088L22.6087 17.3913V0.169375C21.7548 0.0582031 20.8843 0 20 0C19.1159 7.8125e-05 18.2452 0.0582031 17.3913 0.169375L17.3914 17.3912V17.3913H0.169375C0.058125 18.2452 0 19.1159 0 20C7.8125e-05 20.8843 0.058125 21.7548 0.169375 22.6087H17.3913L17.3913 39.8307C18.2453 39.9419 19.1157 40 20 40C20.8843 40 21.7548 39.9419 22.6087 39.8307Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110863">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BasqueCountrySvg;
